<template>
  <label class="d-flex align-items-center gap-1 mb-0 cursor-pointer user-select-none small">
    <input
      type="checkbox"
      v-model="isFilterActive"
      class="form-check-input m-0"
      style="width: 1.2em; height: 1.2em"
    />
    <span class="text-nowrap">自分が作成したもののみ表示</span>
  </label>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

/** applyFilter に渡すキー。他フィルター（clinic_id・タブ等）と AND でマージされる */
const FILTER_KEY = 'createdByMeFilter'

export default defineComponent({
  name: 'DataListCreatedByMeFilter',
  inject: ['ComposableDataListServiceInstance'],
  data() {
    return {
      /** デフォルト ON: 一覧を開いた直後から自分の作成分のみ表示 */
      isFilterActive: true,
    }
  },
  watch: {
    isFilterActive: {
      handler(newVal: boolean) {
        this.updateFilter(newVal)
      },
    },
  },
  mounted() {
    // watch の immediate は使わず、マウント時に初回適用（サービスインスタンス準備後）
    this.updateFilter(this.isFilterActive)
  },
  methods: {
    /**
     * ComposableDataList の動的フィルターを更新する。
     * ON: userCreated がログインユーザー UUID と一致する行のみ
     * OFF: 空オブジェクトで当該キーの条件のみ解除（医院単位のベースフィルターは維持）
     */
    updateFilter(isActive: boolean) {
      const service = this.ComposableDataListServiceInstance as {
        query?: { applyFilter?: (key: string, condition: Record<string, unknown>) => void }
      }
      if (!service?.query?.applyFilter) {
        console.warn(
          '[DataListCreatedByMeFilter] ComposableDataListServiceInstance が取得できないか applyFilter がありません',
        )
        return
      }
      if (isActive) {
        const userUid = $core.$embAuth.userUid
        if (!userUid) {
          console.warn(
            '[DataListCreatedByMeFilter] userUid が未取得のため作成者フィルターは適用しません',
          )
          service.query.applyFilter(FILTER_KEY, {})
          return
        }
        service.query.applyFilter(FILTER_KEY, {
          userCreated: { _eq: userUid },
        })
      } else {
        service.query.applyFilter(FILTER_KEY, {})
      }
    },
  },
})
</script>
